import React from "react";
import {
  ContainerReports,
  ContainerIframe,
} from "./ReportsCoachesContainer.styled";

const ReportsCoachesContainer = () => {
  const iframe =
    '<iframe title="Coaches" src="https://app.powerbi.com/reportEmbed?reportId=76676afa-2cd2-43ad-a9b3-9de0ca62cb08&autoAuth=true&ctid=638fcbaf-ba4c-43e1-adae-5475c970fe10" style="border: 0px; overflow: hidden; width: 100%; height: 100%; min-height: 610px;"></iframe>';

  return (
    <ContainerReports>
      <ContainerIframe
        contentEditable="true"
        dangerouslySetInnerHTML={{ __html: iframe }}
      ></ContainerIframe>
    </ContainerReports>
  );
};

export default ReportsCoachesContainer;
